<template>
  <div class="header">
    <div class="logoTab">
      <div class="logo">
        <router-link to="/index">
          <img class="logoImg" src="@/assets/newImages/images/gaoxinicon.png" alt="">
          <!-- <span class="title">天津滨海高新区政策兑现服务平台</span> -->
        </router-link>
      </div>
      <div class="servephone">
        <img class="serveLogo" src="@/assets/newImages/images/phone.png" alt="">
        <img class="serverhot" src="@/assets/newImages/images/serverhot.jpg" alt="">
        <span class="phoneNum">022-83712738 /</span>
        <span class="phoneNum"> 022-65611009</span>
      </div>
    </div>

    <Navbar></Navbar>
 
    <div class="banner" v-if="personCenter">
      <div class="bannerImg">
        <img src="@/assets/images/header2.jpg" alt="">
        <div class="bannerInner tabsBanner">
          <div class="slogan">
            <span class="indexTitle">{{ userName }}</span>
          </div>
          <!-- <div class="mark">高新 高科技 瞪羚企业 软件公司</div> -->
          <div class="tabs" style="margin-top: 30px;">
            <el-tabs v-model="activeName" :stretch="true" @tab-click="tabClick">
              <el-tab-pane :label="item.title" :name="item.url" v-for="item in routeList" :key="item.name">
              </el-tab-pane> 
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Swiper from './Swiper'
import Navbar from './Navbar'
export default {
  name: 'Header',
  components: {
    Navbar,
    Swiper
  },
  data() {
    return {
      activeName: '',
      routeList: [
        {
          name: "Wdbj",
          url: "/wdbj",
          title: '我的办件'
        },
        {
          name: "Zl",
          url: "/zl",
          title: '我的资料'
        },
        {
          name: "Sc",
          url: "/sc",
          title: '我的收藏'
        }
      ],
      bannerImg: false,
    }
  },
  computed: {
    personCenter() {
      return this.$store.state.user.personCenter;
    },
    userName() {
      return this.$store.state.user.userInfo.companyName
    }
  },
  watch: {
    '$route': {
      handler: function (to, from) {
        if (to.path.indexOf('personcenter') < 0) {
          this.activeName = '/wdbj';
        }
      },
      deep: true
    }
  },
  created() {
    this.changeRoute(this.$route.name);
  },
  methods: {
    tabClick(tab) {
      this.$store.commit('SetTabIndex', 0);
      this.$router.push({path: `/personcenter${this.activeName}`});
    },
    changeRoute(toName) {
      this.routeList.filter(item => {
        if (item.name == toName) {
          this.activeName = item.url;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.branch {
  height: 57px;
  background-color: #fff;
  box-shadow: #ebebeb 0px 0px 20px;
  margin-top: -6px;
  width: 100%;
}

.branchele {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;

  span {
    margin-left: 5px;
  }
}
.header {
  width: 100%;
  background-color: #fff;

  .logoTab {
    width: 1200px;
    margin: 0 auto;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: flex;
      cursor: pointer;

      .title {
        font-size: 28px;
        color: #1651a5;
        font-weight: bold;
      }
    }

    .servephone {
      display: flex;
      justify-content: space-between;

      .serveLogo {
        width: 19px;
        height: 19px;
      }
      .serverhot {
        margin-left: 6px;
        height: 17px;
      }
      .phoneNum {
        font-size: 16px;
        font-weight: bold;
        margin-left: 6px;
      }
    }
  }

  .banner {
    width: 100%;
    position: relative;
    min-width: 1200px;
    .bannerImg {
      width: 100%;
      position: relative;

      img {
        width: 100%;
      }
    }

    .bannerInner {
      position: absolute;
      text-align: center;
      width: 100%;
      top: 16px;
      // height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .slogan {
        display: flex;
        align-items: center;
        justify-content: center;
        .indexTitle {
          font-size: 37px;
          color: #fff;
          margin-left: 17px;
          margin-right: 17px;
        }

        .line {
          width: 132px;
          height: 1px;
          background-color: #fff;
          display: inline-block;
        }
      }

      .mark {
        font-size: 24px;
        margin-top: 20px;
        color: #fff;
      }
    } 

    .bannerInner1 {
      height: 100%;
      z-index: 2;
    }

    .childBanner {
      position: relative;
      img {
        width: 100% ;
      }

      .childBannerContent {
        position: absolute;
        width: 1200px;
        height: 100%;
        top: 0%;
        left: 50%;
        margin-left: -600px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bannerTitle {
          color: #fff;
          font-size: 36px;
          font-weight: bold;
        }
        .bannerSearch {
          height: 50px;
        }
      }
    }
  }

  .tabsBanner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .tabs {
      width: 800px;
      margin: 0 auto;
      margin-top: 20px;
    }
  }

  .bannerLine {
    margin: 0 auto;
    margin-top: 17px;
    width: 1200px;
    border-bottom: 1px dashed #e0e0e0;
  }
  
}
</style>
<style lang="scss">
.tabsBanner {
  .tabs {
    .el-tabs__nav {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .el-tabs__nav-wrap::after {
      top: 0;
      height: 1px;
    }

    .el-tabs__item {
      color: #fff;
    }
    .el-tabs__active-bar {
      top: 0;
      // background-color: #fff;
      height: 3px;
    }
  }
}


</style>